import { useMemo } from 'react';
import { memberId } from '@trello/session-cookie';
import { useMyOwnedBoardsQuery } from './MyOwnedBoardsQuery.generated';
import type { MyOwnedBoardsQuery } from './MyOwnedBoardsQuery.generated';
import { getMyOwnedBoards } from '../getMyOwnedBoards';

type Organization = NonNullable<
  MyOwnedBoardsQuery['member']
>['organizations'][number];

export const useMyOwnedBoards = () => {
  const { data } = useMyOwnedBoardsQuery({
    variables: {
      idMember: memberId || 'me',
    },
    fetchPolicy: 'cache-only',
    waitOn: ['MemberBoards'],
  });

  const member = data?.member;

  const boardsWithOrganizations = useMemo(() => {
    if (!member || !data?.member?.organizations) {
      return [];
    }

    const boards = [];
    const organizationsMap = new Map<string, Organization>();
    member.organizations.forEach((organization) =>
      organizationsMap.set(organization.id, organization),
    );

    // eslint-disable-next-line no-unsafe-optional-chaining
    for (const board of data?.member?.boards) {
      boards.push({
        ...board,
        organization: board.idOrganization
          ? organizationsMap.get(board.idOrganization) ?? null
          : null,
      });
    }

    return boards;
  }, [member, data?.member?.organizations, data?.member?.boards]);

  if (!member) {
    return [];
  }

  return getMyOwnedBoards({
    ...member,
    boards: boardsWithOrganizations,
  });
};
